import React, { useState , useEffect } from "react";
import SaleForm from "./SaleForm";
import Web3 from "web3";
import Button from '@mui/material/Button';
import "./MynftCard.css";
import { ToastContainer, toast } from 'react-toastify';
const eprcontractBurn = require("../EPRCertificate_NFT.json");
const eprcontractAmoy = require("../EPRCertificate_NFTAmoy.json");
const noneprcontractBurn = require("../MyNFT_metadata.json");

var config = require("../../src/config/dev").default;



function MynftCard(props) {
    // console.log("props16",props);
    // const [showModal, setShowModal] = useState(false);

    // Detect if the user is on a mobile device
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isMobile = isAndroid || isIOS;   

    const [numNfts, setNumNfts] = useState("");
    const [cbdcWalletId] = useState(localStorage.getItem("buyerCbdcWalletId") || "");
    const isCbdcOwner = !!(cbdcWalletId && props.owner && props.owner.toLowerCase() === cbdcWalletId.toLowerCase());
    const[qty,setQty] = useState("");
    const [sale, setsale] = useState("");
    const [sale_copies,setsalecopies] = useState("");
    // let quantity = [];
    // let sale_copies1 = "";
    const [sale_copies1,setSaleCopies1] = useState("");
    const [ex,setEx] = useState("");
    // const closeModal = () => setShowModal(false);
    const [showEPRModal, setShowEPRModal] = useState(false);
    const [showNonEPRModal, setShowNonEPRModal] = useState(false);
    const [functionCompleted, setFunctionCompleted] = useState(false);
    const [quantity, setQuantity] = useState("");
    const [nonEprQuantity, setNonEprQuantity] = useState("");
    const[quantity2, setQuantity2] = useState("");
    const[totalQty,settotalQty] = useState("");
    let nftdet = [];
   
    let [val, setVal] = useState("");
    let newimage_link = "";
    console.log("imglink", props.image_link);
    if(props.image_link == null)
    {
      newimage_link = null
    }else{
      newimage_link = props.image_link
    }
    console.log("newimage_link",newimage_link);

    useEffect(() => {
      sessionStorage.setItem("Burndetails", JSON.stringify(props));
      const BurnNFTDetails = JSON.parse(sessionStorage.getItem("Burndetails"));
      console.log("details",BurnNFTDetails);
      const one = BurnNFTDetails.quantity;
      setQuantity(one);
      console.log("qty",quantity);
      settotalQty(one);
      console.log("totalQty",totalQty);
    }, []);
    
    

    const handleNumNftsInput = (event) => {
        const numNfts = parseFloat(event.target.value);
        setNumNfts(numNfts);   
      };

      const handleQtyInput = (event) => {
        const val = event.target.value.replace(/[^0-9]/g, "");
        setQuantity(val);
      };

      const handleNonEprQtyInput = (event) => {
        const val = event.target.value.replace(/[^0-9]/g, "");
        setNonEprQuantity(val);
      };
      
    const handleBurn = async () => {
      // document.getElementById("confirmspin").style.display = "block"
      sessionStorage.setItem("Burndetails", JSON.stringify(props));
      // Retrieve the item from session storage
      const BurnNFTDetails = JSON.parse(sessionStorage.getItem("Burndetails"));
      console.log("details",BurnNFTDetails);
      
      const one = BurnNFTDetails.quantity;
      setQuantity(one);
      setVal(one);
      console.log("val67",val);
      console.log("qty",quantity);
      console.log("one", one);
      console.log("propqty",props.quantity);
      setShowEPRModal(true);
    };

    useEffect(() => {
      console.log("Page loaded nftcard");
      console.log("Quantity updated:", quantity);
    }, [quantity]);

    const handleBurn1 = async () => {
      // document.getElementById("confirmspin").style.display = "block"
      sessionStorage.setItem("Burndetails", JSON.stringify(props));
      // Retrieve the item from session storage
      const BurnNFTDetails = JSON.parse(sessionStorage.getItem("Burndetails"));
      console.log("details",BurnNFTDetails);

      const one = BurnNFTDetails.quantity;
      setNonEprQuantity(String(one));
      console.log("qty",one);
      setShowNonEPRModal(true);
    };

    const handleCloseModal = () => {
      setShowEPRModal(false);
      setShowNonEPRModal(false);
      setNonEprQuantity(String(totalQty));
    };

    const updateBurnNFTDetails = async (assetID,owner,sale_copies) =>{

      var nftDetailsData ={
  
        assetId: assetID,
  
        owner: owner,
  
        burn_copies:sale_copies
  
      }
    

      const url = await fetch(config.API_ENDPOINT+'src/v1/eprnftdetails/update_burnnftdetails',{
        method:"put",
        headers: { "Content-Type": "application/json","x-api-token":sessionStorage.getItem("traceChainAccessToken")},
        body:JSON.stringify(nftDetailsData)       
          
      })
  
  
    }

    const updateNonEPRBurnNFTDetails = async (assetID,owner,sale_copies) =>{

      var nftDetailsData ={

        assetId: assetID,

        owner: owner,

        burn_copies:sale_copies

      }


      const url = await fetch(config.API_ENDPOINT+'src/v1/nftdetails/update_burnnftdetails',{
        method:"put",
        headers: { "Content-Type": "application/json","x-api-token":sessionStorage.getItem("traceChainAccessToken")},
        body:JSON.stringify(nftDetailsData)

      })

    }

    const FabricBurnEPR = async () => {
        if (!isCbdcOwner) {
            toast.error("Only the owner can offset this NFT.", { position: 'top-center', autoClose: 3000 });
            return;
        }
        document.getElementById("confirmspin").style.display = "block";
        const BurnNFTDetails = JSON.parse(sessionStorage.getItem("Burndetails"));
        const owner = BurnNFTDetails.owner;
        const assetId = BurnNFTDetails.assetId;
        const certNumber = BurnNFTDetails.certNumber;
        const burnQty = quantity;
        try {
            const authRes = await fetch(config.API_ENDPOINT + 'api/v1/cbdc/authenticate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-api-token': sessionStorage.getItem('traceChainAccessToken') },
                body: JSON.stringify({ cbdcWalletId })
            });
            const authData = await authRes.json();
            if (!authData.success) throw new Error(authData.errors?.[0]?.msg || 'CBDC authentication failed');
            const cbdcSessionToken = authData.data.sessionToken;

            const burnRes = await fetch(config.API_ENDPOINT + 'api/v1/fabric/nft/burnEPR', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-api-token': sessionStorage.getItem('traceChainAccessToken') },
                body: JSON.stringify({ cbdcSessionToken, assetId, certNumber, owner, burn_copies: burnQty })
            });
            const burnData = await burnRes.json();
            if (!burnData.success) throw new Error(burnData.errors?.[0]?.msg || 'Fabric EPR burn failed');

            await updateBurnNFTDetails(assetId, owner, burnQty);
            document.getElementById("confirmspin").style.display = "none";
            toast.success("NFT Offset successfully on Hyperledger Fabric!", {
                position: 'top-center', autoClose: 3000,
                onClose: () => { window.location.reload(); }
            });
        } catch (err) {
            document.getElementById("confirmspin").style.display = "none";
            console.error("FabricBurnEPR error:", err);
            toast.error(err.message || "EPR Fabric burn failed", { position: 'top-center', autoClose: 3000 });
        }
    };

    const FabricBurnNonEPR = async () => {
        if (!isCbdcOwner) {
            toast.error("Only the owner can offset this NFT.", { position: 'top-center', autoClose: 3000 });
            return;
        }
        document.getElementById("confirmspin").style.display = "block";
        const BurnNFTDetails = JSON.parse(sessionStorage.getItem("Burndetails"));
        const owner = BurnNFTDetails.owner;
        const assetId = BurnNFTDetails.assetId;
        const burnQty = nonEprQuantity;
        try {
            const authRes = await fetch(config.API_ENDPOINT + 'api/v1/cbdc/authenticate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-api-token': sessionStorage.getItem('traceChainAccessToken') },
                body: JSON.stringify({ cbdcWalletId })
            });
            const authData = await authRes.json();
            if (!authData.success) throw new Error(authData.errors?.[0]?.msg || 'CBDC authentication failed');
            const cbdcSessionToken = authData.data.sessionToken;

            const burnRes = await fetch(config.API_ENDPOINT + 'api/v1/fabric/nft/burn', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'x-api-token': sessionStorage.getItem('traceChainAccessToken') },
                body: JSON.stringify({ cbdcSessionToken, assetId, owner, burn_copies: burnQty })
            });
            const burnData = await burnRes.json();
            if (!burnData.success) throw new Error(burnData.errors?.[0]?.msg || 'Fabric Non-EPR burn failed');

            await updateNonEPRBurnNFTDetails(assetId, owner, burnQty);
            document.getElementById("confirmspin").style.display = "none";
            toast.success("NFT Offset successfully on Hyperledger Fabric!", {
                position: 'top-center', autoClose: 3000,
                onClose: () => { window.location.reload(); }
            });
        } catch (err) {
            document.getElementById("confirmspin").style.display = "none";
            console.error("FabricBurnNonEPR error:", err);
            toast.error(err.message || "Non-EPR Fabric burn failed", { position: 'top-center', autoClose: 3000 });
        }
    };


  const monitorTransactionStatus = async (web3, txHash) => {
    let receipt = null;
    while (receipt === null) {
      try {
        receipt = await web3.eth.getTransactionReceipt(txHash);
        if (receipt && receipt.status) {
          return;
        } else if (receipt && !receipt.status) {
          throw new Error("Transaction failed");
        }
      } catch (error) {
        console.log("Error checking transaction status:", error);
        throw error;
      }
      await new Promise(resolve => setTimeout(resolve, 5000)); // Wait for 5 seconds before checking again
    }
  };

    const NoneprBurn = async (owner,sale_copies,assetId) => {
      
      console.log("InNonEPRBurnNFTDetails");
      document.getElementById("confirmspin").style.display = "block"
      const BurnNFTDetails = JSON.parse(sessionStorage.getItem("Burndetails"));

      console.log("BurnNFTDetails",BurnNFTDetails);
      
           
           owner = BurnNFTDetails.owner;
           assetId = BurnNFTDetails.assetId;
           sale_copies = BurnNFTDetails.quantity;
          

            console.log("owner:",owner);
        
            console.log("assetID:",assetId);
        
            console.log("sale_copies:",sale_copies);
              const web3 = new Web3(window.ethereum);

          // Check for mobile MetaMask deep linking
            if (isMobile) {
              const deeplinkUrl = `https://metamask.app.link/dapp/${window.location.hostname}`;
              window.location.href = deeplinkUrl;
              return;
            } 
              await window.ethereum.request({ method: 'eth_requestAccounts' }); 
             
              const accounts = await web3.eth.getAccounts();
              console.log("MetaMask accounts in MynftCard:", accounts);
              const nonce = await web3.eth.getTransactionCount(owner, "latest");


            // const ContractAddress = "0x9C84297B7f08c8f85AE5E18503689C4f11aE70b6"
            const ContractAddress = "0x7B08e049ebae3eCED91a234223D23E97e4B7770e"

        
            const noneprContract = new web3.eth.Contract(noneprcontractBurn.output.abi, ContractAddress);
        
            try{
        
              console.log("details",owner,sale_copies,accounts[0]);
              console.log("TypecertNumb","Typeowner",typeof(owner),"TypeSaleCopies",typeof(sale_copies),"TypeassetId",typeof(assetId));
             
              console.log("Burn Quantity------",nonEprQuantity)
              const gasPrice = await web3.eth.getGasPrice();
              console.log("GasPrice on network",gasPrice);
              // return false;
                const burnResponse= await noneprContract.methods


                  .burnNFT(assetId,owner,nonEprQuantity)
        
                  .send({ 
                    from: owner,
                    gas: 800000, // Added gas limit
                    // gasPrice: web3.utils.toHex(web3.utils.toWei('100', 'gwei')) // Added gas price
                    gasPrice:gasPrice,
                  
                  })
        
                  .on('error', function(error){
        
                    console.log("in on error:", error);
        
                    this.transError="something wrong";
        
                    return error;        
        
                   })
        
                  .then(function(receipt){
        
                    // will be fired once the receipt is mined
        
                    console.log("in then func", receipt);
        
                    console.log("in then receipt",receipt.transactionHash);
        
                    return receipt;
        
                })
                await monitorTransactionStatus(web3, burnResponse.transactionHash);
                console.log("Monitor Transaction",monitorTransactionStatus);
                
                if(burnResponse.status){


                  updateNonEPRBurnNFTDetails(assetId,owner,nonEprQuantity);

                  document.getElementById("confirmspin").style.display = "none";

                  // Show the success toast message here
                  toast.success("NFT Burn successfully", {
                    position: 'top-center',
                    autoClose: 3000,
                    onClose: () => {
                      window.location.reload();
                    }
                  });
                }else if(this.burnResponse.code==4001){
        
                 // Show the error toast message here
                 toast.error("Transaction failed as user denied transaction signature.", {
                  position: 'top-center',
                  autoClose: 3000,
                  onClose: () => {
                    window.location.reload();
                  }
                });
                }else{      
                  toast.error("NFT Burn failed", {
                    position: 'top-center',
                    autoClose: 3000,
                    onClose: () => {
                      window.location.reload();
                    }
                  });
                }
        
                
            }catch(err){
        
              console.log("error:::",err);
              console.error("Error in MetaMask detection in Mynftcard:", err);
        
              if(err.value == "NaN"){
                toast.error("Error : "+"Quantity cannot be null", {
                  position: 'top-center',
                  autoClose: 3000,
                  onClose: () => {
                    window.location.reload();
                  }
                });
              } else {
                toast.error(err.message, {
                  position: 'top-center',
                  autoClose: 3000,
                  onClose: () => {
                    window.location.reload();
                  }
                });
              }
        
            }
    }

    const Burn = async (owner,sale_copies,assetId,certNumber) => {
      

      document.getElementById("confirmspin").style.display = "block"
      const BurnNFTDetails = JSON.parse(sessionStorage.getItem("Burndetails"));

      console.log("BurnNFTDetails",BurnNFTDetails);
      
           
           owner = BurnNFTDetails.owner;
           assetId = BurnNFTDetails.assetId;
           sale_copies = BurnNFTDetails.quantity;
           certNumber = BurnNFTDetails.certNumber;
           
            console.log("owner:",owner);
        
            console.log("assetID:",assetId);
        
            console.log("sale_copies:",sale_copies);
        
            console.log("certNumber:",certNumber);

                const web3 = new Web3(window.ethereum);

          
          // Check for mobile MetaMask deep linking
            if (isMobile) {
                const deeplinkUrl = `https://metamask.app.link/dapp/${window.location.hostname}`;
                window.location.href = deeplinkUrl;
                return;
            }


                await window.ethereum.request({ method: 'eth_requestAccounts' });
                const accounts = await web3.eth.getAccounts();
                const nonce = await web3.eth.getTransactionCount(owner, "latest");


            // const EPRContractAddress = "0xe4DC3879CdA3C14f2ceA57ec7b8c516b24800644"
            const EPRContractAddress = "0x1c36a5B65a44744f0F536b922edd07669aF8565e"
            
        
            const eprContract = new web3.eth.Contract(eprcontractBurn.output.abi, EPRContractAddress);
      
            try{
        
              console.log("certNum",certNumber,owner,sale_copies,accounts[0]);
              console.log("TypecertNumb",typeof(certNumber),"Typeowner",typeof(owner),"TypeSaleCopies",typeof(sale_copies),"TypeassetId",typeof(assetId));
             
              console.log("Burn Quantity------",numNfts)
              console.log("Burn Quantity 2------",quantity)
              // return false;
                const burnResponse= await eprContract.methods
        
                  .burnNFT(certNumber,owner,quantity)
                  // .burnNFT(certNumber,owner,numNfts)
        
                  .send({ 
                    from: owner,
                    gas: 800000, // Added gas limit
                    gasPrice: web3.utils.toWei('100', 'gwei') // Added gas price
                  
                  })
        
                  .on('error', function(error){
        
                    console.log("in on error:", error);
        
                    this.transError="something wrong";
        
                    return error;        
                    
                   })
        
                  .then(function(receipt){
        
                    // will be fired once the receipt is mined
        
                    console.log("in then func", receipt);
        
                    console.log("in then receipt",receipt.transactionHash);
        
                    return receipt;
        
                })
        
                if(burnResponse.status){

                  updateBurnNFTDetails(assetId,owner,quantity);
                  // updateBurnNFTDetails(assetId,owner,numNfts);
                  document.getElementById("confirmspin").style.display = "none";

                  // Show the success toast message here
                  toast.success("NFT Burn successfully", {
                    position: 'top-center',
                    autoClose: 3000,
                    onClose: () => {
                      window.location.reload();
                    }
                  });
                }else if(this.burnResponse.code==4001){
                 console.log(this.burnResponse.message);
                 console.log(this.burnResponse.code);
                 // Show the error toast message here
                 toast.error("Transaction failed as user denied transaction signature.", {
                  position: 'top-center',
                  autoClose: 3000,
                  onClose: () => {
                    // window.location.reload();
                  }
                });
                }else{
                  toast.error("NFT Burn failed", {
                    position: 'top-center',
                    autoClose: 3000,
                    onClose: () => {
                      // console.log(err.message);
                      // window.location.reload();
                    }
                  });
                }
        
                
            }catch(err){
        
              console.log("error:::",err.value);
        
              if(err.value == "NaN"){
              toast.error("Error : "+"Quantity cannot be null", {
                position: 'top-center',
                autoClose: 3000,
                onClose: () => {
                  console.log(err.message);
                  // window.location.reload();
                }
              });
            } else {
              toast.error(err.message, {
                position: 'top-center',
                autoClose: 3000,
                onClose: () => {
                  console.log(err.message);
                  // window.location.reload();
                }
              });
            }
        
            }
    }


    // Called by the seller to approve the EPR contract as operator and mark tokens on-sale on-chain.
    // This is required before a buyer can call transfer() — ERC1155 auth check needs isApprovedForAll(seller, contract).
    const handleApproveForSale = async () => {
        try {
            const web3 = new Web3(window.ethereum);
            await window.ethereum.request({ method: 'eth_requestAccounts' });
            const accounts = await web3.eth.getAccounts();
            const seller = accounts[0];

            const EPRContractAddress = "0x1c36a5B65a44744f0F536b922edd07669aF8565e";
            const eprContract = new web3.eth.Contract(eprcontractAmoy.output.abi, EPRContractAddress);
            const gasPrice = await web3.eth.getGasPrice();

            // Step 1: approve the contract to transfer seller's tokens on their behalf
            const isApproved = await eprContract.methods.isApprovedForAll(seller, EPRContractAddress).call();
            if (!isApproved) {
                toast.info("Step 1/2: Approving contract to transfer your tokens (confirm in MetaMask)...", { position: 'top-center', autoClose: 4000 });
                await eprContract.methods.setApprovalForAll(EPRContractAddress, true).send({ from: seller, gas: 100000, gasPrice });
            }

            // Step 2: register on-sale quantity on-chain so the contract's tokensOnSale check passes.
            // Use saleCopy (DB on-sale qty) if set; otherwise fall back to total ownedCopies.
            const saleCopies = Number(props.saleCopy) || Number(props.quantity) || 0;
            if (props.certNumber && saleCopies > 0) {
                toast.info("Step 2/2: Registering tokens on sale (confirm in MetaMask)...", { position: 'top-center', autoClose: 4000 });
                await eprContract.methods.putOnSaleGrid(props.certNumber, saleCopies).send({ from: seller, gas: 200000, gasPrice });
            } else if (!props.certNumber) {
                toast.warning("Certificate number missing — cannot register on sale on-chain. Please contact admin.", { position: 'top-center', autoClose: 6000 });
            }

            toast.success("Approved! Buyers can now purchase your tokens.", { position: 'top-center', autoClose: 4000 });
        } catch (err) {
            console.error("Approve for sale error:", err);
            if (err.code === 4001) {
                toast.error("Approval cancelled by user.", { position: 'top-center', autoClose: 3000 });
            } else {
                toast.error(err.message || "Approval failed. Please try again.", { position: 'top-center', autoClose: 4000 });
            }
        }
    };


    return (
<>

        <div id="confirmspin" className="loader" style={{ display: "none" }}>Loading...</div>

        <div className="card col-3 product-card">
          
            {props?.assetType == "NonEPRAsset" ?(
                      props?.image_link && !props?.image_link.toLowerCase().endsWith('.pdf') ? (
                        // If image_link is not blank, display the image
                        <img src={props?.image_link} className="card-img-top img-card"/>
                    ) : (
                        // If image_link is blank and extension is Pdf, display a default image
                    <>
                    <div className="noneprimagemynftcard card-img-top img-card">
                    </div>
                    </>
                    )
                    ):
                    (
                        <>
                            <div className="eprimagecard card-img-top img-card">
                                <div alt="nft" style={{fontSize: "17px", paddingTop: "80px", position: "absolute", bottom: "266px", left: "50%", transform: "translateX(-50%)", textAlign: "center"}}>
                                  {"Plastic Credit"}
                                </div>
                                <div alt="nft" style={{fontSize: "17px", paddingBottom: "20px", position: "absolute", bottom: "228px", left: "50%", transform: "translateX(-50%)", textAlign: "center"}}>
                                  {props?.totalcopy} {props?.UOM}
                                </div>
                            </div>
                        </>

                    )}
          
            <div className="card-body">
              <div className="text-left">
                        
                    <p className="card-text" style={{ width: 200, fontSize : "12px" }}>Supplier - {props.ownerName}</p>
                    <p className="card-text" style={{ width: 200, fontSize : "12px" }}>Product Name - {props.name}</p>
                    <p className="card-text" style={{ width: 200, fontSize : "12px" }}>Product ID - {props.assetId}</p>
                    <p className="card-text" style={{ width: 200, fontSize : "12px" }}>Owned Quantity - {props.quantity} {props.UOM}</p>
                    <p className="card-text" style={{ width: 200, fontSize : "12px" }}>Platform - {props.network_type}</p>
                 
                    <div className="text-center" hidden={props.assetType == "NonEPRAsset"}>
                    <button className="Burnbuttoncard"
                    onClick={handleBurn}
                    >
                        Offset Credits
                    </button>
                    {/* {Number(props.quantity) > 0 && (
                    <button
                        className="Burnbuttoncard"
                        style={{ marginTop: "6px", background: "#1976d2", color: "#fff" }}
                        onClick={handleApproveForSale}
                        title="Sellers must click this once before buyers can purchase. Signs two MetaMask transactions: setApprovalForAll + putOnSaleGrid."
                    >
                        Approve for Sale
                    </button>
                    )} */}
                    </div>

                    <div className="text-center" hidden={props.assetType == "EPRAsset"}>
                    <button className="Burnbuttoncard"
                    onClick={handleBurn1}
                    >
                        Offset Credits
                    </button>
                    </div>
                    <ToastContainer/>
                </div>
                   

{/* **************************EPR Modal ******************************************************************                 */}
       <div
                  className={`modal${showEPRModal ? " show" : ""}`}
                  id="exampleModal"
                  tabIndex="-1"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden={!showEPRModal}
                  role="dialog"
                  style={{ display: showEPRModal ? "block" : "none" }}
                >
                 

        
        <div className="modal-dialog" role="document">
          <div className="modal-content" style={{marginTop : "160px"}} >
            <div className="modal-header" style={{paddingTop:"2px", paddingBottom:"2px", paddingLeft:"3px",paddingRight:"3px"}}>
              <h6 className="modal-title" id="exampleModalLabel" >
                Offset Credits
              </h6>
              <button
                type="button"
                className="btn-close"

                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
          
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="eprQtyInput" style={{fontSize:"12px"}}>Quantity</label>
                <input
                  required
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  className="form-control"
                  id="eprQtyInput"
                  value={quantity}
                  onChange={handleQtyInput}
                />
                {console.log("inside div element")}
                {console.log("qty",qty)}
                {console.log("numNfts",numNfts)}
                {console.log("quantity",quantity)}
                {console.log("totalQty",totalQty)}
              
                 {(quantity)<=0 && <div className="error-message">Please provide Quantity greater than 0</div>}
                 {/* {!numNfts && numNfts==0 && <div className="error-message">Please provide Quantity greater than 0</div>} */}
                 {totalQty < quantity && <div className="error-message">Quantity must be lesser than or Equal to Owned quantity!</div>}
                 {cbdcWalletId && !isCbdcOwner && <div className="error-message">Only the owner ({props.owner}) can offset this NFT.</div>}

              </div>


              <div className="modal-footer text-center button-section-epr">
               <div className="buttonpadding">
                <div>
              <Button
                type="button"
                className="buttonclosemodal model-cancel-button"

                onClick={handleCloseModal}
                >
                CANCEL
              </Button>
               <Button

                type="button"
                className="buttonclosemodal offset-crredit"

                disabled={quantity == 0 || quantity == null || quantity > totalQty || (cbdcWalletId && !isCbdcOwner)}
                onClick={isCbdcOwner ? FabricBurnEPR : Burn}
                >
                Offset Credits
                </Button>
             
             
              </div>
            
              </div> 
            </div>
              
            
              
            </div>
         
          </div>
        </div>
      </div>


{/* ************************NonEPR Modal******************************************************************** */}
        <div
                  className={`modal${showNonEPRModal ? " show" : ""}`}
                  id="ModalNonEPR"
                  tabIndex="-1"
                  aria-labelledby="ModalNonEPRLabel"
                  aria-hidden={!showNonEPRModal}
                  style={{ display: showNonEPRModal ? "block" : "none" }}
                  role="dialog"

                >
                 

        
        <div className="modal-dialog" role="document">
          <div className="modal-content" style={{marginTop : "160px"}}>
            <div className="modal-header" style={{paddingTop:"2px", paddingBottom:"2px", paddingLeft:"3px",paddingRight:"3px"}}>
              <h6 className="modal-title" id="ModalNonEPRLabel">
                Offset Credits
              </h6>
              <button
                type="button"
                className="btn-close"

                aria-label="Close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="nonEprQtyInput" style={{fontSize:"12px"}}>Quantity</label>
                <input
                  required
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  className="form-control"
                  id="nonEprQtyInput"
                  value={nonEprQuantity}
                  onChange={handleNonEprQtyInput}
                />
                 {Number(nonEprQuantity) <= 0 && <div className="error-message">Please provide Quantity greater than 0</div>}
                 {Number(nonEprQuantity) > Number(totalQty) && <div className="error-message">Quantity must be lesser than or Equal to Owned quantity!</div>}
                 {cbdcWalletId && !isCbdcOwner && <div className="error-message">Only the owner ({props.owner}) can offset this NFT.</div>}
              </div>


              <div className="modal-footer text-center button-section-nonepr">
               <div className="buttonpadding">
                <div>
              <Button
                type="button"
                className="buttonclosemodal model-cancel-button"

                onClick={handleCloseModal}
                >
                CANCEL
              </Button>
               <Button

                type="button"
                className="buttonclosemodal offset-crredit"

                disabled={!nonEprQuantity || Number(nonEprQuantity) <= 0 || Number(nonEprQuantity) > Number(totalQty) || (cbdcWalletId && !isCbdcOwner)}
                onClick={isCbdcOwner ? FabricBurnNonEPR : NoneprBurn}
                >
                Offset Credits
              </Button>
             
              </div>

           </div>   
          </div>  
        </div>
      </div>
      </div>
      </div>
  </div>



        

</div>
       
</>
    )

   
}

export default MynftCard;